import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 项目分页
export function getProjectPager(req, pager) {
  return request({
    url: apiConfig.projectInfo.api.pager.url,
    method: "post",
    data: {
      metaName: req.projectName,
      metaCode: req.projectCode,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}

// 项目分页搜索功能
export function searchProjectPager(req, pager) {
  return request({
    url: apiConfig.projectInfo.api.pager.url,
    method: "post",
    data: {
      metaName: req.projectName,
      metaCode: req.projectCode,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}
// 编辑项目
export function editProject(req) {
  return request({
    url: apiConfig.projectInfo.api.edit.url,
    method: "post",
    data: {
      id: req.id,
      metaName: req.projectName
    }
  });
}

// 删除项目
export function deleteProject(req) {
  return request({
    url: apiConfig.projectInfo.api.delete.url,
    method: "post",
    data: {
      id: req.id,
      isdel: 0
    }
  });
}
